/* Keeps --app-height in sync with the visual viewport so the fixed-height
   shell shrinks above the mobile on-screen keyboard. Android Chrome 108+
   handles this via the viewport meta's interactive-widget=resizes-content;
   iOS Safari (and WKWebView) never resize the layout viewport when the
   keyboard opens, so we mirror the visual viewport into a CSS var that
   #root consumes: height: min(var(--app-height, 100vh), 100%).

   Height is scale-compensated (height × scale ≈ layout-viewport height):
   a pinch-zoom shrinks visualViewport.height proportionally to scale on
   every platform (including desktop touchscreens / macOS trackpads), and
   without the compensation the whole app would collapse to the zoomed
   window. With it, zooming leaves the var ≈ 100% and only a keyboard
   (scale stays 1, height drops alone) shrinks the shell. */

export function initAppHeightVar(): void {
  const root = document.documentElement;
  const vv = window.visualViewport;
  const update = () => {
    const h = vv ? vv.height * vv.scale : window.innerHeight;
    root.style.setProperty('--app-height', `${Math.round(h)}px`);
    // iOS pans the layout viewport to keep a focused bottom input visible;
    // once the shell has shrunk to fit above the keyboard that pan just
    // misaligns the app (top bar pushed off-screen). Cancel it — but never
    // fight an intentional pinch-zoom pan (scale > 1).
    if (vv && vv.scale === 1 && (vv.offsetTop > 0 || window.scrollY > 0)) {
      window.scrollTo(0, 0);
    }
  };
  update();
  vv?.addEventListener('resize', update);
  vv?.addEventListener('scroll', update);
  window.addEventListener('resize', update);
}
